/** CoStar.Api.Lookup.GlobalTypeAhead.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["Company"] = 9] = "Company";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["SaleCompID"] = 32] = "SaleCompID";
    MatchType[MatchType["MSA"] = 35] = "MSA";
    MatchType[MatchType["PropertyGroup"] = 36] = "PropertyGroup";
    MatchType[MatchType["ContactSaleComp"] = 81] = "ContactSaleComp";
    MatchType[MatchType["ContactLeaseDeal"] = 83] = "ContactLeaseDeal";
    MatchType[MatchType["ContactTenant"] = 84] = "ContactTenant";
    MatchType[MatchType["ContactProperty"] = 85] = "ContactProperty";
    MatchType[MatchType["CompanySaleComp"] = 91] = "CompanySaleComp";
    MatchType[MatchType["CompanyLeaseDeal"] = 93] = "CompanyLeaseDeal";
    MatchType[MatchType["CoStarMarket"] = 132] = "CoStarMarket";
})(MatchType || (MatchType = {}));
